export function capitalize(string:string) {
  if (string && string.length > 1) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return string;
  }
}
